<p-dropdown *ngIf="editable" [options]="delegates" id="selectedDelegate" name="selectedDelegate" [(ngModel)]="selectedDelegate" [placeholder]="Validation.DropdownPlaceholder"
  (onChange)="onChangeDelegate(selectedDelegate)" styleClass="submitted-dropdown" required>
  <ng-template let-delegate pTemplate="item">
    {{delegate.label}}
  </ng-template>
</p-dropdown>
  <button *ngIf="editable&&delegateNotFound" pButton class="icon-warn" icon="fa fa-exclamation-triangle"
          pTooltip="You don't have delegation access for {{orignialSubmittedForUser?.fullName}}.Any updates made will mark you as Submitted For."
          tooltipPosition="top"> </button>

<span class="submittedfor-text"><div *ngIf="!editable&&orignialSubmittedForUser">
  {{orignialSubmittedForUser?.fullName}}
</div></span>
